import React from 'react';
import Barritas from "./../img/Opciones/Barritas.jpg"
import Artesanales from "./../img/Opciones/Artesanales.jpg"
import Bebidas from "./../img/Opciones/Bebidas.jpg"
import Barras from "./../img/Opciones/Barras.jpg"
import Tortas from "./../img/Opciones/Tortas.jpg"

import "./../css/Opciones.css"

function Opciones() {
    let opciones = [
        {
            name: "Barritas",
            img: Barritas
        },
        {
            name: "Artesanales en pala",
            img: Artesanales
        },
        {
            name: "Bebidas frias",
            img: Bebidas
        },
        {
            name: "Barras",
            img: Barras
        },
        {
            name: "Tortas",
            img: Tortas
        }
    ];

    return (
        <section className='opciones'>
            <div className='opciones__titulo'>
                <div className='opciones__titulo__titulo'>
                    <p className='opciones__titulo__titulo__categorias'>
                        CATEGORIAS
                    </p>
                    <h2 className='opciones__titulo__titulo__heladas'>
                        Heladas
                    </h2>
                </div>
                <p className='opciones__titulo__tipos'>
                    CHOCOLATOSOS-CREMOSOS-BEBIBLES-FRUTALES-SALUDABLES
                </p>
            </div>
            <div className='opciones__opciones'>
                {opciones.map((op, index) => (
                    <div className='opciones__opciones__img'>
                        <img src={op.img} alt={op.name} key={index} className='opciones__opciones__img__img'/>
                        <div className='opciones__opciones__img__tapa'>
                            <h3 className='opciones__opciones__img__tapa__nombre'>{op.name}</h3>
                            <button className='opciones__opciones__img__tapa__boton'>
                                Ver opciones
                            </button>
                        </div>
                    </div>
                ))}
            </div>

        </section>
    );
}

export default Opciones;
